@if (canView()) {
	<lb-detail-widget iconName="untitled-ui/security/lock-01">
		<div class="entitlements">
			<div class="entitlements-header">
				<span class="md-text-sm-semibold">Entitlements</span>
				@if (canOpenAccess()) {
					<a md-button [routerLink]="[peoplePath, userID()]">Manage access</a>
				}
			</div>

			@if (loading()) {
				<lb-loader size="small"></lb-loader>
			} @else if (failed()) {
				<span class="md-text-sm-regular">Could not load entitlements.</span>
			} @else {
				@for (name of entitlementNames(); track name) {
					<span class="md-text-sm-regular">{{ name }}</span>
				} @empty {
					<span class="md-text-sm-regular">None</span>
				}
			}
		</div>
	</lb-detail-widget>
}
